import React from 'react';
import BlogPage from '../../components/Blog/BlogPage';
import BlogImg1 from '../../assets/images/blog/blog-1-1.jpg'
import BlogImg2 from '../../assets/images/blog/blog-1-2.jpg'
import BlogImg3 from '../../assets/images/blog/blog-1-3.jpg'
import BlogImg4 from '../../assets/images/blog/blog-1-4.jpg'
import BlogImg5 from '../../assets/images/blog/blog-1-5.jpg'
import BlogImg6 from '../../assets/images/blog/blog-1-6.jpg'


const BlogMain = () => {
    const blogData = [
        {
          imgSrc: BlogImg1,
          author: 'admin',
          date: '23 December 2023',
          title: 'Trust the experts for all your roof service needs',
          link: '/blog-details',
          animationDirection: 'Left',
          delay: 100,
        },
        {
          imgSrc: BlogImg2,
          author: 'admin',
          date: '23 December 2023',
          title: 'Enhance the functionality of your roof with our service',
          link: '/blog-details',
          animationDirection: 'Up',
          delay: 200,
        },
        {
          imgSrc: BlogImg3,
          author: 'admin',
          date: '23 December 2023',
          title: 'Functionality of your roof with our service',
          link: '/blog-details',
          animationDirection: 'Right',
          delay: 300,
        },
        {
          imgSrc: BlogImg4,
          author: 'admin',
          date: '23 December 2023',
          title: 'Enhance the beau functionality of your our service',
          link: '/blog-details',
          animationDirection: 'Right',
          delay: 300,
        },
        {
          imgSrc: BlogImg5,
          author: 'admin',
          date: '23 December 2023',
          title: 'Functionality of your roof with our service',
          link: '/blog-details',
          animationDirection: 'Right',
          delay: 300,
        },
        {
          imgSrc: BlogImg6,
          author: 'admin',
          date: '23 December 2023',
          title: 'Trust the experts for all your roof service needs',
          link: '/blog-details',
          animationDirection: 'Right',
          delay: 300,
        },
        // Add more blog objects as needed...
      ];

    return (
        <React.Fragment>
            <BlogPage blogs={blogData} />
        </React.Fragment>
    );
};

export default BlogMain;
